<template>
  <div class="mt-5">
    <v-layout wrap>
      <v-flex>
        <!-- Header Section -->
        <v-row class="pa-4 pb-0 pt-0">
          <v-col cols="12" class="pb-1">
            <v-card flat color="transparent">
              <div class="d-flex align-center">
                <div class="d-flex align-center">
                  <v-avatar tile size="22">
                    <v-img
                      contain
                      alt="statistik"
                      :src="require('@/assets/image/grip_menu.png')"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height" align="center" justify="center">
                          <v-progress-circular
                            size="20"
                            indeterminate
                            :color="set_color"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span class="fs-16 black--text ml-2" style="font-weight: 600">
                    Statistik & Laporan
                  </span>
                </div>

                <v-spacer />
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Date Range Filter -->
        <!-- <div class="filter-wrapper">
          <v-row class="pa-4 py-0">
            <v-col cols="12" md="12" lg="12" class="pb-2"> -->
              <v-card 
                flat 
                class="filter-card filter-sticky mx-4 my-2"
                :style="`
                  border-radius: 6px;
                  border: 1px solid rgba(255, 255, 255, 0.1);
                  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
                  background: #1e293b;
                  transition: all 0.3s ease;
                  position: ${filterStickyStyle.position};
                  top: ${filterStickyStyle.top};
                  z-index: ${filterStickyStyle.zIndex};
                `"
              >
              <!-- Header Section -->
              <div 
                class="filter-header"
                :style="`
                  background: rgba(0, 0, 0, 0.2);
                  border-radius: 6px 6px 0 0;
                  padding: 12px 12px 12px 12px;
                  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                `"
              >
                <div class="d-flex align-center">
                  <v-avatar 
                    size="40" 
                    style="background: rgba(255, 255, 255, 0.15);"
                    class="mr-3"
                  >
                    <v-icon color="white" size="22">mdi-filter-variant</v-icon>
                  </v-avatar>
                  <div class="flex-grow-1">
                    <div class="fs-16 font-weight-bold white--text">
                      Filter & Pencarian
                    </div>
                    <div class="fs-11 white--text mt-n1" style="opacity: 0.8;">
                      Pilih periode dan fasilitas untuk melihat statistik
                    </div>
                  </div>
                  <v-btn
                    icon
                    small
                    @click="filterCollapsed = !filterCollapsed"
                    color="white"
                    class="ml-2"
                    style="opacity: 0.9;"
                  >
                    <v-icon color="white">{{ filterCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-expand-transition>
                <v-card-text v-show="!filterCollapsed" class="pa-4 pt-2">
                <v-row>
                  <v-col cols="12" md="4" class="py-0">
                    <div class="filter-label mb-2">
                      <v-icon small color="white" class="mr-1">mdi-calendar-clock</v-icon>
                      <span class="fs-13 font-weight-bold white--text">Tanggal Mulai</span>
                    </div>
                    <v-menu
                      v-model="menu.start"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedStartDate"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          outlined
                          hide-details
                          class="filter-input"
                          :style="`
                            border-radius: 6px;
                            background: white;
                          `"
                          :color="set_color"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.start_date"
                        @input="handleStartDateChange()"
                        :color="set_color"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <div class="filter-label mb-2">
                      <v-icon small color="white" class="mr-1">mdi-calendar-check</v-icon>
                      <span class="fs-13 font-weight-bold white--text">Tanggal Selesai</span>
                    </div>
                    <v-menu
                      v-model="menu.end"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="formattedEndDate"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          outlined
                          hide-details
                          class="filter-input"
                          :style="`
                            border-radius: 6px;
                            background: white;
                          `"
                          :color="set_color"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.end_date"
                        @input="menu.end = false; fetchData()"
                        :min="filter.start_date"
                        :color="set_color"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <div class="filter-label mb-2">
                      <v-icon small color="white" class="mr-1">mdi-domain</v-icon>
                      <span class="fs-13 font-weight-bold white--text">Pilih Fasilitas</span>
                    </div>
                    <v-select
                      v-model="filter.product_id"
                      :items="productOptions"
                      item-text="text"
                      item-value="value"
                      dense
                      outlined
                      hide-details
                      prepend-inner-icon="mdi-office-building"
                      class="filter-input"
                      :style="`
                        border-radius: 6px;
                        background: white;
                      `"
                      :color="set_color"
                      @change="fetchData()"
                    ></v-select>
                  </v-col>
                </v-row>
                <!-- <v-row class="mt-1">
                </v-row> -->
                </v-card-text>
              </v-expand-transition>
            </v-card>
          <!-- </v-col>
        </v-row>
        </div> -->

        <!-- Summary Cards -->
        <v-row class="pa-4 py-0">
          <v-col cols="12" sm="6" md="3" v-for="(card, index) in summaryCards" :key="index">
            <v-card
              class="summary-card"
              :style="`
                border-radius: 6px;
                background: linear-gradient(135deg, ${card.color1} 0%, ${card.color2} 100%);
                box-shadow: 0 8px 24px rgba(0,0,0,0.12);
              `"
              elevation="0"
            >
              <v-card-text class="pa-5">
                <div class="d-flex align-center justify-space-between">
                  <div class="flex-grow-1">
                    <div class="white--text fs-13 mb-3" style="opacity: 0.95; font-weight: 500;">
                      {{ card.title }}
                    </div>
                    <div class="white--text fs-24 font-weight-bold mb-3" style="line-height: 1.2;">
                      {{ card.value }}
                    </div>
                  </div>
                  <v-avatar size="70" :color="card.iconBg" class="ml-3">
                    <v-icon size="36" color="white">{{ card.icon }}</v-icon>
                  </v-avatar>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Charts Row 1: Revenue Line Chart and Orders Bar Chart -->
        <v-row class="pa-4 py-0">
          <v-col cols="12" md="8">
            <v-card
              flat
              style="border-radius: 6px; border: 1px solid #e7e7e7; box-shadow: 0 4px 16px rgba(0,0,0,0.08)"
            >
              <v-card-title class="pb-2">
                <v-icon :color="set_color" class="mr-2">mdi-chart-line</v-icon>
                <span class="fs-16 font-weight-bold">Grafik Pendapatan</span>
                <v-spacer />
                <v-chip small :color="set_color" text-color="white" class="fs-11">
                  Total: {{ formatCurrency(totalRevenue) }}
                </v-chip>
              </v-card-title>
              <v-divider />
              <v-card-text v-if="!process.load">
                <apexchart
                  type="area"
                  height="300"
                  :options="revenueChartOptions"
                  :series="revenueChartSeries"
                ></apexchart>
              </v-card-text>
              <v-card-text v-else class="text-center py-8">
                <v-progress-circular indeterminate :color="set_color"></v-progress-circular>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card
              flat
              style="border-radius: 6px; border: 1px solid #e7e7e7; box-shadow: 0 4px 16px rgba(0,0,0,0.08); height: 100%"
            >
              <v-card-title class="pb-2">
                <v-icon :color="set_color" class="mr-2">mdi-chart-donut</v-icon>
                <span class="fs-16 font-weight-bold">Status Order</span>
              </v-card-title>
              <v-divider />
              <v-card-text v-if="!process.load">
                <apexchart
                  type="donut"
                  height="300"
                  :options="statusChartOptions"
                  :series="statusChartSeries"
                ></apexchart>
              </v-card-text>
              <v-card-text v-else class="text-center py-8">
                <v-progress-circular indeterminate :color="set_color"></v-progress-circular>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Charts Row 2: Facility Orders Bar Chart and Product Distribution -->
        <v-row class="pa-4 py-0">
          <v-col cols="12" md="7">
            <v-card
              flat
              style="border-radius: 6px; border: 1px solid #e7e7e7; box-shadow: 0 4px 16px rgba(0,0,0,0.08)"
            >
              <v-card-title class="pb-2">
                <v-icon :color="set_color" class="mr-2">mdi-chart-bar</v-icon>
                <span class="fs-16 font-weight-bold">Total Order per Fasilitas</span>
              </v-card-title>
              <v-divider />
              <v-card-text v-if="!process.load">
                <apexchart
                  type="bar"
                  height="350"
                  :options="facilityChartOptions"
                  :series="facilityChartSeries"
                ></apexchart>
              </v-card-text>
              <v-card-text v-else class="text-center py-8">
                <v-progress-circular indeterminate :color="set_color"></v-progress-circular>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="5">
            <v-card
              flat
              style="border-radius: 6px; border: 1px solid #e7e7e7; box-shadow: 0 4px 16px rgba(0,0,0,0.08); height: 100%"
            >
              <v-card-title class="pb-2">
                <v-icon :color="set_color" class="mr-2">mdi-chart-pie</v-icon>
                <span class="fs-16 font-weight-bold">Distribusi Pendapatan</span>
              </v-card-title>
              <v-divider />
              <v-card-text v-if="!process.load">
                <apexchart
                  type="pie"
                  height="350"
                  :options="distributionChartOptions"
                  :series="distributionChartSeries"
                ></apexchart>
              </v-card-text>
              <v-card-text v-else class="text-center py-8">
                <v-progress-circular indeterminate :color="set_color"></v-progress-circular>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Top Facilities Table -->
        <v-row class="pa-4 py-0 pb-4">
          <v-col cols="12">
            <v-card
              flat
              style="border-radius: 6px; border: 1px solid #e7e7e7; box-shadow: 0 4px 16px rgba(0,0,0,0.08)"
            >
              <v-card-title class="pb-2">
                <v-icon :color="set_color" class="mr-2">mdi-star</v-icon>
                <span class="fs-16 font-weight-bold">Top 3 Fasilitas Terpopuler</span>
              </v-card-title>
              <v-divider />
              <v-card-text v-if="!process.load" class="pa-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left" :style="`background-color: ${set_color}15`">
                          <span class="font-weight-bold">Ranking</span>
                        </th>
                        <th class="text-left" :style="`background-color: ${set_color}15`">
                          <span class="font-weight-bold">Nama Fasilitas</span>
                        </th>
                        <th class="text-center" :style="`background-color: ${set_color}15`">
                          <span class="font-weight-bold">Total Order</span>
                        </th>
                        <th class="text-right" :style="`background-color: ${set_color}15`">
                          <span class="font-weight-bold">Total Pendapatan</span>
                        </th>
                        <th class="text-center" :style="`background-color: ${set_color}15`">
                          <span class="font-weight-bold">Persentase</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in topFacilities" :key="index">
                        <td>
                          <v-chip
                            small
                            :color="index === 0 ? 'amber' : index === 1 ? 'grey lighten-1' : index === 2 ? 'orange lighten-1' : 'grey lighten-2'"
                            :text-color="index < 3 ? 'white' : 'grey darken-2'"
                          >
                            <v-icon small left v-if="index < 3">mdi-medal</v-icon>
                            {{ index + 1 }}
                          </v-chip>
                        </td>
                        <td class="font-weight-medium">{{ item.name }}</td>
                        <td class="text-center">
                          <v-chip small :color="set_color" text-color="white">
                            {{ item.orders }}
                          </v-chip>
                        </td>
                        <td class="text-right font-weight-bold" :style="`color: ${set_color}`">
                          {{ formatCurrency(item.revenue) }}
                        </td>
                        <td class="text-center">
                          <v-progress-linear
                            :value="item.percentage"
                            :color="set_color"
                            height="20"
                            rounded
                          >
                            <span class="white--text fs-11 font-weight-bold">{{ item.percentage }}%</span>
                          </v-progress-linear>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text v-else class="text-center py-8">
                <v-progress-circular indeterminate :color="set_color"></v-progress-circular>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { get } from "@/service/Axios";
import moment from "moment";
import "moment/locale/id";

export default {
  data() {
    return {
      menu: {
        start: false,
        end: false,
      },
      filter: {
        start_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        product_id: null, // null = Semua
      },
      process: {
        load: false,
      },
      message: {
        error: '',
      },
      filterCollapsed: false,
      
      // Real data from API
      products: [],
      orders: [],
      
      // Summary Cards Data
      summaryCards: [
        {
          title: "Total Order",
          value: "0",
          trend: "+12% dari bulan lalu",
          trendIcon: "mdi-trending-up",
          icon: "mdi-shopping",
          color1: "#5e35b1",
          color2: "#4527a0",
          iconBg: "rgba(255,255,255,0.2)",
        },
        {
          title: "Total Pendapatan",
          value: "Rp 0",
          trend: "+8% dari bulan lalu",
          trendIcon: "mdi-trending-up",
          icon: "mdi-cash-multiple",
          color1: "#e91e63",
          color2: "#c2185b",
          iconBg: "rgba(255,255,255,0.2)",
        },
        {
          title: "Fasilitas Aktif",
          value: "0",
          trend: "3 fasilitas baru",
          trendIcon: "mdi-plus",
          icon: "mdi-domain",
          color1: "#1e88e5",
          color2: "#0d47a1",
          iconBg: "rgba(255,255,255,0.2)",
        },
        {
          title: "Rata-rata Order",
          value: "Rp 0",
          trend: "+5% dari bulan lalu",
          trendIcon: "mdi-trending-up",
          icon: "mdi-chart-line-variant",
          color1: "#00897b",
          color2: "#00695c",
          iconBg: "rgba(255,255,255,0.2)",
        },
      ],

      // Revenue Chart Data
      revenueChartSeries: [
        {
          name: "Pendapatan",
          data: [],
        },
      ],
      revenueChartOptions: {
        chart: {
          type: "area",
          height: 300,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.2,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return "Rp " + (value / 1000).toFixed(0) + "K";
            },
            style: {
              fontSize: "12px",
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return "Rp " + value.toLocaleString("id-ID");
            },
          },
        },
        colors: ["#667eea"],
      },

      // Facility Chart Data
      facilityChartSeries: [
        {
          name: "Total Order",
          data: [],
        },
      ],
      facilityChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: false,
            columnWidth: "60%",
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "11px",
            },
            rotate: -45,
            rotateAlways: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        fill: {
          opacity: 1,
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.5,
            gradientToColors: ["#667eea"],
            inverseColors: false,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [0, 100],
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " Order";
            },
          },
        },
        colors: ["#764ba2"],
      },

      // Status Chart Data
      statusChartSeries: [],
      statusChartOptions: {
        chart: {
          type: "donut",
        },
        labels: [],
        colors: ["#667eea", "#43e97b", "#f5576c", "#ffa726"],
        legend: {
          position: "bottom",
          fontSize: "12px",
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  fontSize: "16px",
                  fontWeight: "bold",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " Order";
            },
          },
        },
      },
      
      // Status Order dari sistem
      orderStatuses: [
        {
          text: 'Dalam Proses',
          value: 'dalam proses',
          color: '#667eea'
        },
        {
          text: 'Diterima',
          value: 'diterima',
          color: '#43e97b'
        },
        {
          text: 'Ditolak',
          value: 'ditolak',
          color: '#f5576c'
        },
        {
          text: 'Expired',
          value: 'expired',
          color: '#ffa726'
        }
      ],

      // Distribution Chart Data
      distributionChartSeries: [],
      distributionChartOptions: {
        chart: {
          type: "pie",
        },
        labels: [],
        colors: [
          "#FF6B6B", // Merah coral
          "#4ECDC4", // Turquoise
          "#45B7D1", // Biru muda
          "#FFA07A", // Salmon
          "#98D8C8", // Mint
          "#FFD93D", // Kuning
          "#6BCF7F", // Hijau
          "#C38AFF", // Ungu muda
          "#FF8ED4", // Pink
          "#A8DADC", // Biru pastel
          "#F4A261", // Orange
          "#2A9D8F", // Teal
        ],
        legend: {
          position: "bottom",
          fontSize: "12px",
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            fontWeight: "bold",
          },
          formatter: function (val, opts) {
            return val.toFixed(1) + "%";
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "Rp " + val.toLocaleString("id-ID");
            },
          },
        },
      },

      // Top Facilities Data
      topFacilities: [],
      
      totalRevenue: 0,
    };
  },
  computed: {
    set_color() {
      return this.$store.state.color;
    },
    set_color_rgba_08() {
      const color = this.set_color;
      if (color.startsWith('#')) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, 0.08)`;
      }
      return color;
    },
    set_color_rgba_25() {
      const color = this.set_color;
      if (color.startsWith('#')) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, 0.25)`;
      }
      return color;
    },
    productOptions() {
      const options = [
        { text: "Semua", value: null }
      ];
      
      if (this.products && this.products.length > 0) {
        this.products.forEach(product => {
          options.push({
            text: product.name,
            value: product.id
          });
        });
      }
      
      return options;
    },
    formattedStartDate() {
      if (!this.filter.start_date) return '';
      return moment(this.filter.start_date).format('DD MMMM YYYY');
    },
    formattedEndDate() {
      if (!this.filter.end_date) return '';
      return moment(this.filter.end_date).format('DD MMMM YYYY');
    },
    filterStickyStyle() {
      // Disable sticky di mobile (xs, sm), aktifkan di desktop (md ke atas)
      const isMobile = this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
      
      if (isMobile) {
        return {
          position: 'relative',
          top: 'auto',
          zIndex: 1,
        };
      }
      
      return {
        position: 'sticky',
        top: '68px',
        zIndex: 10,
      };
    },
  },
  async mounted() {
    moment.locale('id');
    await this.fetchProducts();
    this.fetchData();
  },
  methods: {
    formatCurrency(value) {
      return "Rp " + value.toLocaleString("id-ID");
    },

    handleStartDateChange() {
      this.menu.start = false;
      
      // Jika start_date lebih besar dari end_date, set end_date sama dengan start_date
      if (this.filter.start_date && this.filter.end_date) {
        if (moment(this.filter.start_date).isAfter(moment(this.filter.end_date))) {
          this.filter.end_date = this.filter.start_date;
        }
      }
      
      this.fetchData();
    },

    async fetchProducts() {
      try {
        const response = await get(`admin/product/data`, {
          params: {
            limit: 1000,
            page: 1,
            sort: '-id'
          }
        });
        
        if (response.data.status === 200) {
          this.products = response.data.results.data;
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },

    generateDummyData() {
      this.process.load = true;

      // Generate dummy dates for the selected period
      const dates = [];
      const revenueData = [];
      const daysCount = moment(this.filter.end_date).diff(
        moment(this.filter.start_date),
        "days"
      ) + 1;

      for (let i = 0; i < daysCount; i++) {
        const date = moment(this.filter.start_date).add(i, "days");
        dates.push(date.format("DD MMM"));
        revenueData.push(Math.floor(Math.random() * 5000000) + 1000000);
      }

      // Update revenue chart
      this.revenueChartOptions = {
        ...this.revenueChartOptions,
        xaxis: {
          ...this.revenueChartOptions.xaxis,
          categories: dates,
        },
      };
      this.revenueChartSeries = [
        {
          name: "Pendapatan",
          data: revenueData,
        },
      ];

      // Calculate total revenue
      this.totalRevenue = revenueData.reduce((a, b) => a + b, 0);

      // Use real facilities from API or fallback to dummy
      let facilities = [];
      let facilityOrders = [];
      let facilityRevenue = [];

      if (this.products.length > 0) {
        // Use real product names
        facilities = this.products.map(p => p.name);
        facilityOrders = this.products.map(() =>
          Math.floor(Math.random() * 50) + 10
        );
        facilityRevenue = this.products.map(() =>
          Math.floor(Math.random() * 10000000) + 2000000
        );
      } else {
        // Fallback to dummy data
        facilities = [
          "Gedung Pertemuan A",
          "Aula Serbaguna",
          "Lapangan Futsal",
          "Kolam Renang",
          "Ruang Meeting",
          "Gedung Pertemuan B",
          "Studio Musik",
          "Lapangan Basket",
        ];
        facilityOrders = facilities.map(() =>
          Math.floor(Math.random() * 50) + 10
        );
        facilityRevenue = facilities.map(() =>
          Math.floor(Math.random() * 10000000) + 2000000
        );
      }

      // Update facility chart
      this.facilityChartOptions = {
        ...this.facilityChartOptions,
        xaxis: {
          ...this.facilityChartOptions.xaxis,
          categories: facilities,
        },
      };
      this.facilityChartSeries = [
        {
          name: "Total Order",
          data: facilityOrders,
        },
      ];

      // Update distribution chart
      this.distributionChartOptions = {
        ...this.distributionChartOptions,
        labels: facilities,
      };
      this.distributionChartSeries = facilityRevenue;

      // Update status chart with real status from order system
      const statuses = this.orderStatuses.map(s => s.text);
      const statusCounts = [
        Math.floor(Math.random() * 100) + 50,  // Dalam Proses
        Math.floor(Math.random() * 150) + 80,  // Diterima
        Math.floor(Math.random() * 30) + 10,   // Ditolak
        Math.floor(Math.random() * 40) + 15,   // Expired
      ];

      this.statusChartOptions = {
        ...this.statusChartOptions,
        labels: statuses,
        colors: this.orderStatuses.map(s => s.color),
      };
      this.statusChartSeries = statusCounts;

      // Calculate total orders
      const totalOrders = statusCounts.reduce((a, b) => a + b, 0);
      const totalFacilities = facilities.length;
      const avgOrder = this.totalRevenue / totalOrders;

      // Update summary cards
      this.summaryCards[0].value = totalOrders.toString();
      this.summaryCards[1].value = this.formatCurrency(this.totalRevenue);
      this.summaryCards[2].value = totalFacilities.toString();
      this.summaryCards[3].value = this.formatCurrency(Math.floor(avgOrder));

      // Generate top facilities
      const totalRevenueSum = facilityRevenue.reduce((a, b) => a + b, 0);
      this.topFacilities = facilities
        .map((name, index) => ({
          name,
          orders: facilityOrders[index],
          revenue: facilityRevenue[index],
          percentage: Math.round((facilityRevenue[index] / totalRevenueSum) * 100),
        }))
        .sort((a, b) => b.revenue - a.revenue)
        .slice(0, 5);

      setTimeout(() => {
        this.process.load = false;
      }, 1000);
    },

    async fetchData() {
      this.process.load = true;
      this.message = { error: '' };

      try {
        const params = {
          start_date: this.filter.start_date,
          end_date: this.filter.end_date
        };

        // Add product_id to params if not null (not "Semua")
        if (this.filter.product_id !== null) {
          params.product_id = this.filter.product_id;
        }

        const response = await get(`admin/dashboard/total`, { params });
        
        if (response.data.status === 200) {
          const data = response.data.results;
          this.processApiData(data);
        } else {
          console.error("API Error:", response.data.message);
          // Fallback to dummy data if API fails
          this.generateDummyData();
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        // Fallback to dummy data if API fails
        this.generateDummyData();
      } finally {
        this.process.load = false;
      }
    },

    processApiData(data) {
      // Process data from API response
      // Update summary cards with real data
      const totalOrders = data.total_order || 0;
      const totalRevenue = data.total_pendapatan || 0;
      const totalFacilities = data.total_fasilitas || 0;
      const avgOrder = data.total_rata_rata_nominal_order || 0;

      this.totalRevenue = totalRevenue;

      this.summaryCards[0].value = totalOrders.toString();
      this.summaryCards[1].value = this.formatCurrency(totalRevenue);
      this.summaryCards[2].value = totalFacilities.toString();
      this.summaryCards[3].value = this.formatCurrency(Math.floor(avgOrder));

      // Update revenue chart from arr_grafik_pendapatan (object with date keys)
      if (data.arr_grafik_pendapatan) {
        const dates = Object.keys(data.arr_grafik_pendapatan).map(date => 
          moment(date).format("DD MMM")
        );
        const revenueData = Object.values(data.arr_grafik_pendapatan);

        this.revenueChartOptions = {
          ...this.revenueChartOptions,
          xaxis: {
            ...this.revenueChartOptions.xaxis,
            categories: dates,
          },
        };
        this.revenueChartSeries = [
          {
            name: "Pendapatan",
            data: revenueData,
          },
        ];
      }

      // Update facility chart from arr_total_order_per_product
      if (data.arr_total_order_per_product && data.arr_total_order_per_product.length > 0) {
        const facilities = data.arr_total_order_per_product.map(item => item.product_name);
        const facilityOrders = data.arr_total_order_per_product.map(item => item.total_order || 0);

        this.facilityChartOptions = {
          ...this.facilityChartOptions,
          xaxis: {
            ...this.facilityChartOptions.xaxis,
            categories: facilities,
          },
        };
        this.facilityChartSeries = [
          {
            name: "Total Order",
            data: facilityOrders,
          },
        ];
      }

      // Update distribution chart from arr_persentase_nominal_order_per_product
      if (data.arr_persentase_nominal_order_per_product && data.arr_persentase_nominal_order_per_product.length > 0) {
        const productNames = data.arr_persentase_nominal_order_per_product.map(item => item.product_name);
        const productRevenue = data.arr_persentase_nominal_order_per_product.map(item => item.total_nominal_order || 0);

        this.distributionChartOptions = {
          ...this.distributionChartOptions,
          labels: productNames,
        };
        this.distributionChartSeries = productRevenue;
      }

      // Update status chart from arr_persentase_status_order
      if (data.arr_persentase_status_order) {
        const statusData = data.arr_persentase_status_order;
        const statuses = [];
        const statusCounts = [];
        const statusColors = [];

        // Map status data based on orderStatuses
        // API uses underscore format: "dalam_proses_count", "diterima_count", etc.
        this.orderStatuses.forEach(status => {
          // Convert status value to API format (replace space with underscore)
          const apiStatusKey = status.value.replace(/\s+/g, '_');
          const countKey = `${apiStatusKey}_count`;
          
          if (statusData[countKey] !== undefined) {
            statuses.push(status.text);
            statusCounts.push(statusData[countKey]);
            statusColors.push(status.color);
          }
        });

        this.statusChartOptions = {
          ...this.statusChartOptions,
          labels: statuses,
          colors: statusColors,
        };
        this.statusChartSeries = statusCounts;
      }

      // Update top facilities from arr_top_3_products (or arr_persentase_nominal_order_per_product for top 5)
      const topProductsData = data.arr_top_3_products || data.arr_persentase_nominal_order_per_product || [];
      if (topProductsData.length > 0) {
        this.topFacilities = topProductsData
          .map(item => ({
            name: item.product_name,
            orders: item.total_order || 0,
            revenue: item.total_nominal_order || 0,
            percentage: item.percentage || 0,
          }))
          .sort((a, b) => b.revenue - a.revenue)
          .slice(0, 5);
      }
    },
  },
};
</script>

<style scoped>
.summary-card {
  transition: all 0.3s ease;
  cursor: pointer;
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18) !important;
}

.filter-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: visible;
}

.filter-card:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important; */
}

.filter-wrapper {
  position: relative;
  width: 100%;
}

.filter-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  will-change: transform, box-shadow;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Saat sticky, pastikan background solid */
.filter-sticky[style*="position: sticky"] {
  background: #1e293b !important;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
}

/* Animasi saat sticky aktif - shadow lebih kuat */
.filter-sticky[style*="position: sticky"] {
  animation: stickyAppear 0.3s ease-out;
}

@keyframes stickyAppear {
  from {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  }
  to {
    box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  }
}

.filter-sticky:hover {
  /* box-shadow: 0 10px 35px rgba(0, 0, 0, 0.18) !important; */
  transform: translateY(-1px);
}

/* Responsive - disable sticky di mobile */
@media (max-width: 959px) {
  .filter-sticky {
    position: relative !important;
    top: auto !important;
  }
}

.filter-header {
  transition: all 0.3s ease;
}

.filter-label {
  display: flex;
  align-items: center;
  color: white;
  transition: all 0.2s ease;
}

.filter-input {
  transition: all 0.3s ease;
}

.filter-input >>> .v-input__control {
  transition: all 0.3s ease;
}

.filter-input >>> .v-input__control:hover {
  transform: translateY(-1px);
}

.filter-input >>> .v-text-field__slot input {
  font-size: 13px;
  font-weight: 500;
  color: #424242;
}

.filter-input >>> .v-select__selection {
  font-size: 13px;
  font-weight: 500;
  color: #424242;
}

.filter-input >>> fieldset {
  border-width: 1.5px !important;
  transition: all 0.3s ease;
}

.filter-input >>> .v-input--is-focused fieldset {
  border-width: 2px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.fs-11 {
  font-size: 11px;
}

.fs-12 {
  font-size: 12px;
}

.fs-13 {
  font-size: 13px;
}

.fs-14 {
  font-size: 14px;
}

.fs-16 {
  font-size: 16px;
}

.fs-24 {
  font-size: 24px;
}
</style>

